import { commonImageContainer, flexCenter } from '@/archive/styles/mixins';
import Image from 'next/image';
import { ROOT_MARGIN, values } from '@/archive/constants/company';
import { css } from '@emotion/css';
import React, { useEffect, useState } from 'react';
import { getRecentModifiedImageUrl } from '@/archive/utils/imageUtils';
import Head from 'next/head';
const wrapperStyle = (backgroundColor: string) => css`
  width: 100%;
  ${flexCenter()};
  background-color: ${backgroundColor || ''};
`;

const isMeetFirst = (viewHeight: number, preAccumulatedHeight: number) => {
  return viewHeight + ROOT_MARGIN > preAccumulatedHeight;
};

const CompanyPage = () => {
  const { contents } = values;
  const { backgroundColors, sizes } = contents;
  const [viewHeight, setViewHeight] = useState(0);

  useEffect(() => {
    setViewHeight(window.innerHeight);
  }, []);

  let accumulatedHeight = 0;

  return (
    <>
      <Head>
        <meta
          property="og:title"
          itemProp="title name"
          content="단비교육 회사소개 더 알아보기"
        />
        <meta property="og:site_name" content="단비교육 회사소개 더 알아보기" />
        <meta
          property="og:description"
          itemProp="description"
          content={
            '단비교육은 더 나은 교육으로 행복한 삶의 출발을 함께하고자 노력하는 에듀테크 기업입니다.'
          }
        />
        <meta
          name="description"
          content="단비교육은 더 나은 교육으로 행복한 삶의 출발을 함께하고자 노력하는 에듀테크 기업입니다."
        />
        <title>단비교육 회사소개 더 알아보기</title>
      </Head>
      {Array.from({ length: contents.imgCount }).map((_, index) => {
        const imageUrl = getRecentModifiedImageUrl(index + 1, contents);
        const { width, height } = sizes[index];
        const backgroundColor = backgroundColors[index];
        const preAccumulatedHeight = accumulatedHeight;
        accumulatedHeight += height;

        return (
          <div key={imageUrl} className={wrapperStyle(backgroundColor)}>
            <div className={commonImageContainer}>
              <Image
                src={imageUrl}
                alt=""
                width={width}
                height={height}
                priority={isMeetFirst(viewHeight, preAccumulatedHeight)}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CompanyPage;
